import PropTypes from 'prop-types';

import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import 'highcharts/highcharts-more';

import { columnRangeChartConfiguration } from './utilities/helpers';
import { exportMenuOptions } from '../Chart/components/ExportMenu/utilities/helpers';

const ColumnRangeChart = ({ series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      exportMenuOptions={[exportMenuOptions[0]]}
      options={merge({}, columnRangeChartConfiguration, {
        series,
        type: 'columnrange',
        xAxis,
        yAxis,
        ...props,
      })}
      {...props}
    />
  );
};

ColumnRangeChart.propTypes = {
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default ColumnRangeChart;
